import { Popover } from '@mui/material';
import { generateTestId } from '@vs/functions/generate-test-id';
import { onEnterTriggerClick } from '@vs/functions/on-enter-trigger-click';
import { AppsIcon } from '@vs/ui/vs-icons';
import classNames from 'classnames';
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AppButton } from './AppButton';
import { testIdName } from './constants';
import { useProductList } from './useProductList';

type PropsPortalAppsPanel = {
  className?: string;
};

export const PortalAppsPanel = memo(({ className }: PropsPortalAppsPanel) => {
  const { t } = useTranslation(['shared']);
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const list = useProductList();

  return (
    <>
      <div
        {...generateTestId('btn-like', [testIdName])}
        className={classNames(
          'p-2 cursor-pointer transition-colors hover:bg-neutral-300 rounded',
          className
        )}
        onClick={e => setAnchorEl(e.currentTarget)}
        onKeyDown={onEnterTriggerClick}
        tabIndex={0}
        role="button"
        aria-label={t('aria_label.btn_other_apps')}
      >
        <AppsIcon className="text-lg" />
      </div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            ...generateTestId('popover', [testIdName]),
            className:
              'w-80 px-6 py-3 flex flex-col rounded-lg !shadow-md border border-vs-neut-200',
          },
        }}
      >
        <div className="vs-body-xs-regular text-vs-base-content-variant mb-1">
          {t('apps_panel.title')}
        </div>
        <div className="max-h-[354px] flex items-center flex-wrap">
          {list
            .filter(d => !d.hide)
            .map(d => (
              <AppButton
                key={d.name}
                name={d.name}
                Icon={d.Icon}
                href={d.href}
              />
            ))}
        </div>
      </Popover>
    </>
  );
});
